import moment from 'moment';
import { find, get } from 'lodash';

import { createSelector } from 'reselect';
import { reportMap } from '../constants/reports';
import { translate } from '../../utils/translation-utils';
import { formatDate } from '../../utils/common-utils';

// Date
export const selectedDateOptionSelector = state => get( state, 'reportsConfig.selectedDateRange.option' );
export const selectedStartDateSelector = state => get( state, 'reportsConfig.selectedDateRange.start' );
export const selectedEndDateSelector = state => get( state, 'reportsConfig.selectedDateRange.end' );

export const formattedStartDateSelector = createSelector(
    selectedStartDateSelector,
    ( startDate ) => {
        return formatDate( startDate, 'day' );
    } );
export const formattedEndDateSelector = createSelector(
    selectedEndDateSelector,
    ( endDate ) => {
        return formatDate( endDate, 'day' );
    } );
export const daysInRangeSelector = createSelector(
    selectedStartDateSelector,
    selectedEndDateSelector,
    ( startDate, endDate ) => {
        const start = moment( startDate );
        const end = moment( endDate );

        // include the start date in the result using + 1
        return end.diff( start, 'days' ) + 1;
    } );

// Pickers
export const selectedIntervalSelector = state => get( state, 'reportsConfig.selectedInterval' );
export const selectedDomainSelector = state => get( state, 'reportsConfig.selectedDomain', '' );
export const selectedDomainTypeSelector = state => get( state, 'reportsConfig.selectedDomainType', 'all' );
export const selectedDmarcPassTypeSelector = state => get( state, 'reportsConfig.selectedDmarcPassType', 'single' );
export const tabIndexSelector = state => get( state, 'uiState.reports.reportTabIndex', 0 );

// PDF
export const isFetchingPdfSelector = state => get( state, 'exportReport.isFetchingPdf', false );
export const isFetchingChartImageSelector = state => get( state, 'exportReport.isFetchingChartImage', {} );

const grabChartName = ( state, chartName ) => {
    const chartImageState = isFetchingChartImageSelector( state );
    return get( chartImageState, chartName, false );
};

export const isFetchingChartNameSelector = createSelector(
    [grabChartName],
    ( chartName ) => {
        return chartName || false;
    }
);
// Report-Specific
const currentReportSelector = createSelector( tabIndexSelector,
    ( tabIndex ) => {
        return find( reportMap, { index: tabIndex } );
    } );

export const reportHeaderSelector = createSelector(
    formattedStartDateSelector,
    formattedEndDateSelector,
    selectedIntervalSelector,
    selectedDomainTypeSelector,
    selectedDomainSelector,
    currentReportSelector,
    ( startDate, endDate, interval, domainType, domain, currentReport ) => {
        const header = {
            endDate,
            interval,
            startDate,
            title: currentReport.title,
        };

        if( currentReport.url === 'policy-progress' && domainType ){
            header.domainType = translate( `${domainType}-domains` );
        }

        if( currentReport.url === 'domain-progress' ){
            header.domain = domain || 'All domains';
        }

        return header;
    }
);
export const exportParamsSelector = createSelector(
    selectedDateOptionSelector,
    selectedIntervalSelector,
    selectedDomainSelector,
    selectedDomainTypeSelector,
    selectedDmarcPassTypeSelector,
    currentReportSelector,
    ( dateOption, interval, domain, domainType, dmarcPassType, currentReport ) => {
        return {
            dateRange: dateOption,
            dmarcPassType,
            domain: domain || undefined,
            domainType,
            interval,
            report: currentReport.url
        };
    } );
export const currentReportParamsSelector = createSelector(
    selectedStartDateSelector,
    selectedEndDateSelector,
    selectedIntervalSelector,
    selectedDomainTypeSelector,
    ( startDate, endDate, interval, domainType ) => {
        const params = {
            endDate: endDate,
            interval: interval,
            startDate: startDate,
        };

        if( domainType ){
            params.domainType = domainType;
        }

        return params;

    }
);
